import * as angular from 'angular';
import './flexi-modal-header.component.scss';
import { Component,Output, EventEmitter } from 'ng-metadata/core';

/**
 * @ngdoc directive
 * @name mwFlexiModalHeader
 * @module mw.components.dialog
 *
 * @description
 * `<mw-flexi-modal-header>` is a component used to generate an standard MW fleximodal header
 *
 * @param {expression} [on-close] - Angular expression to evaluate when the close button is clicked in the fleximodal.  $event is the ng-click event that triggered cancel.
 *
 * @usage
 * <hljs hljs-language="html">
 *   <mw-flexi-modal-header on-close="$crl.onClose($event)">Flexi modal</mw-flexi-modal-header>
 * </hljs>
 *
 */

@Component({
    selector: 'mw-flexi-modal-header',
    template: `
        <md-toolbar layout="column">
            <div class="md-toolbar-tools mw-button__container--dark">
                <md-icon class="mw-flexi-modal-header__logo-icon" md-svg-src="icons/meltwater-icons/eyecon-glyph.svg"></md-icon>
                <h2><ng-transclude></ng-transclude></h2>
                <div flex=""></div>
                <mw-icon-button class="mw-flexi-modal-header__close-icon-button" svg-icon="navigation:ic_close_24px" ng-click="$ctrl.handleClose($event)" hover="true"></mw-icon-button>
            </div>
        </md-toolbar>
    `,
    legacy: {
        transclude: true
    }
})
export class FlexiModalHeaderComponent {

    @Output() onClose = new EventEmitter<ng.IAngularEvent>();

    constructor() {

    }

    handleClose(event) {
        this.onClose.emit(event);
    }
}


// WEBPACK FOOTER //
// ./src/lib/components/dialog/flexi-modal/header/flexi-modal-header.component.ts